import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import { Tabs, Tab } from "react-bootstrap";
import { DropdownButton, Dropdown } from "react-bootstrap";
import Pagination from "react-js-pagination";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import {
  clearUserList,
  fetchUserList,
  fetchTotalUsers,
  searchUser,
  sortUser,
  sortUserByCategory,
  fetchUserbyUserStatus,
  fetchUsersCategory,
  fetchEventDetails,
  deleteBulkAppUser,
  bulkDeleteAllAppUser,
  appuserBasicDataUpdate,
  sendBulkWelcomeMail,
  fetchBulkUplodedLeftUsers,
  manageUserGroupModal,
  fetchUserListForManageUserGroup,
  sortUserByDateOrder,
} from "DashboardUserAction";
import { fetchSettings, fetchAllTickets } from "TicketAction";
import { fetchTemplate } from "SettingActions";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchAllSpeakers } from "ActionsSpeakers";
import { fetchAllSponsors } from "ActionsSponsors";
import { fetchAllExhibitors } from "ActionsExhibitors";
import { fetchUserInterests } from "ActionsMessage";
import {
  itemCount,
  COMMON_FAIL_MESSAGE,
  DEVELOPMENT_TYPE,
  screenHeightLeftFromTop,
} from "Constants";
import NoContent, { NO_USER, SELECTEDTAB } from "NoContent";
import AddUserDialog from "./components/dashboard-add-user";
import ImportUsersDialog from "./components/import-users";
import DashboardUserItem from "./components/dashboard-user-item";
import ExportUsers from "./components/export-user";
import UserResetPassword from "UserResetPassword";
import EmailPreview from "./components/email-preview";
import ManageUsersGroup from "ManageUsersGroup";
import ManageAppuserGroup from "ManageAppuserGroup";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      alphabets: [],
      search: "",
      sortByCategory: "all",
      sort: "all",
      selectedUsers: [],
      allCheck: false,
      actionOption: false,
      showEmailPreviewModal: false,
      activeLoader: false,
      desc: LocaleStrings.preparingUsers,
      selectedTab: 1,
    };

    this.handleUserStatusTab = this.handleUserStatusTab.bind(this);
    this.toggleFilterByCreatedOn = this.toggleFilterByCreatedOn.bind(this);
    this.handleSelectAllUsers = this.handleSelectAllUsers.bind(this);
    this.onSearchUser = this.onSearchUser.bind(this);

    this.processQueue = false;
    this.intervalUserList = null;

    this.confirmButtonOk = React.createRef();
  }

  componentDidMount() {
    //this.props.userOrderByDateCreated.orderBy holds state for asc or desc
    this.props.fetchUserList(this.props.session);
    // this.props.fetchBulkUplodedLeftUsers(this.props.session);
    this.props.fetchTotalUsers(this.props.session);
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchTemplate(this.props.session);
    this.props.fetchAllSpeakers(this.props.session);
    this.props.fetchAllSponsors(this.props.session);
    this.props.fetchAllExhibitors(this.props.session);
    this.props.fetchUserInterests(this.props.session);
    this.props.fetchEventDetails(this.props.session);
    this.props.fetchSettings(this.props.session);
    this.props.fetchAllTickets(this.props.session);
    this.props.sortUserByDateOrder("asc");
    this.alphabetsFun("all");

    /**
     * This is used only for keeping dashboard functionality (like search user, sort user pagination) as it is,
     *  coz we need to check if any user is importing from cron, than that users will list in dashboard.
     */

    // This below code is comment by VKP, as now we are not importing user in appuser_temp table, we are directly calling the api to import user in appuser table. (05/07/23)

    // this.intervalUserList = setInterval(() => {
    //   this.props.fetchBulkUplodedLeftUsers(this.props.session);
    //   this.reloadPageData();

    //   if (this.props.bulkUplodingLeft && this.props.bulkUplodingLeft.count > 0)
    //     this.processQueue = true;
    //   else this.processQueue = false;

    //   if (!this.processQueue) {
    //     this.clearInterval();
    //   }
    // }, 15000);
  }

  componentWillUnmount() {
    this.clearInterval();
  }

  clearInterval = () => {
    clearInterval(this.intervalUserList);
    this.intervalUserList = null;
    this.processQueue = false;
  };

  openGroupManageModal = () => {
    this.props.manageUserGroupModal({ showModal: true });
    this.props.fetchUserListForManageUserGroup(this.props.session);
  };

  showEmailPreviewModal = (e) => {
    // this.setState({showEmailPreviewModal: true})
  };

  closeEmailPreviewModal = (e) => {
    // this.setState({showEmailPreviewModal: false})
  };

  clearAllData = (e) => {
    this.setState({
      showEmailPreviewModal: false,
      selectedUsers: [],
      allCheck: false,
      actionOption: false,
    });
  };

  callbackUploadUser = () => {
    if (!this.intervalUserList) {
      this.intervalUserList = setInterval(() => {
        this.props.fetchBulkUplodedLeftUsers(this.props.session);
        this.reloadPageData();

        if (
          this.props.bulkUplodingLeft &&
          this.props.bulkUplodingLeft.count > 0
        )
          this.processQueue = true;
        else this.processQueue = false;

        if (!this.processQueue) {
          this.clearInterval();
        }
      }, 5000);
    }
  };

  reloadPageData = () => {
    this.props.fetchTotalUsers(this.props.session);
    this.paginationCallback(this.state.pageNumber);
  };

  reloadTotalUserData = () => {
    this.props.fetchTotalUsers(this.props.session);
  };

  userAdditionCallback = () => {
    // after update call this method with page no. as param, it will display as your current search or sort rocord
    this.paginationCallback(this.state.pageNumber);
  };

  // Function to disable confirmation button after ok click
  loadConfirmationButton = () => {
    // console.log(this.confirmButtonOk);

    this.confirmButtonOk.current.innerText = LocaleStrings.button_processing;
    this.confirmButtonOk.current.style.opacity = "0.5";
    this.confirmButtonOk.current.style.cursor = "default";
    this.confirmButtonOk.current.disabled = true;

    this.confirmButtonOk.current.nextSibling.style.opacity = "0.5";
    this.confirmButtonOk.current.nextSibling.style.cursor = "default";
    this.confirmButtonOk.current.nextSibling.disabled = true;
  };

  // Sent bulk emails
  sendBulkEmail = (key) => {
    let { session } = this.props;
    let { selectedUsers } = this.state;
    // console.log("key :- ", key);
    // console.log("selectedUsers :- ", selectedUsers);

    let users = [];
    if (key === "email_selected_confirmed") {
      selectedUsers.map((val, index) => {
        if (val.isactive == 1 && val.userwaitlistmode == 0) {
          let obj = {
            username: val.username,
            eventid: session.eventid,
            logtype: "email",
            playerid: val.playerid ? val.playerid : null,
            emailid: val.email,
            logstatus: "pending",
            content: "Welcome confirmed email",
            createdbyid: session.userid,
            userstatus: "confirmed",
          };
          users.push(obj);
        }
      });
    } else if (key === "email_selected_waitlist") {
      selectedUsers.map((val, index) => {
        if (val.userwaitlistmode == 1) {
          let obj = {
            username: val.username,
            eventid: session.eventid,
            logtype: "email",
            playerid: val.playerid ? val.playerid : null,
            emailid: val.email,
            logstatus: "pending",
            content: "Welcome waitlist email",
            createdbyid: session.userid,
            userstatus: "waitlist",
          };
          users.push(obj);
        }
      });
    }
    // console.log("users :- ", users);

    if (users.length > 0) {
      this.setState({ activeLoader: true });
      this.props.sendBulkWelcomeMail(session, users, (response) => {
        this.setState({ activeLoader: false });
        if (response.success === 1) {
          this.clearAllData();
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
        } else {
          this.clearAllData();
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    } else {
      if (key === "email_selected_confirmed") {
        this.props.showError(
          LocaleStrings.user_validation_message_welcome_email_sent
        );
      } else if (key === "email_selected_waitlist") {
        this.props.showError(
          LocaleStrings.user_validation_message_waitlist_email_sent
        );
      }
    }
  };

  // Update bulk appuser status and send email
  updateBulkUserStatus = (key) => {
    // move_selected_confirmed, move_email_selected_confirmed, move_selected_waitlist, move_email_selected_waitlist, move_selected_inactive
    // console.log("key :- ", key);

    let { session, userList } = this.props;
    let { selectedUsers, pageNumber } = this.state;
    let userId = session.userid;

    var checkSelfAdmin = _.filter(selectedUsers, function (selusers) {
      return selusers.appuserid == userId;
    });

    // Check super admin in selected appuser list
    var checkSuperAdmin = _.filter(selectedUsers, function (selusers) {
      return selusers.issuperadmin;
    });

    let users = [];
    let emailuser = [];
    if (
      key === "move_selected_confirmed" ||
      key === "move_email_selected_confirmed"
    ) {
      selectedUsers.map((val, index) => {
        let obj = {
          appuserid: val.appuserid,
          eventid: session.eventid,
          isactive: 1,
          userwaitlistmode: 0,
        };
        users.push(obj);

        let obj1 = {
          username: val.username,
          eventid: session.eventid,
          logtype: "email",
          playerid: val.playerid ? val.playerid : null,
          emailid: val.email,
          logstatus: "pending",
          content: "Welcome confirmed email",
          createdbyid: session.userid,
          userstatus: "confirmed",
        };
        emailuser.push(obj1);
      });
    } else if (
      key === "move_selected_waitlist" ||
      key === "move_email_selected_waitlist"
    ) {
      selectedUsers.map((val, index) => {
        let obj = {
          appuserid: val.appuserid,
          eventid: session.eventid,
          isactive: 1,
          userwaitlistmode: 1,
        };
        users.push(obj);

        let obj1 = {
          username: val.username,
          eventid: session.eventid,
          logtype: "email",
          playerid: val.playerid ? val.playerid : null,
          emailid: val.email,
          logstatus: "pending",
          content: "Welcome waitlist email",
          createdbyid: session.userid,
          userstatus: "waitlist",
        };
        emailuser.push(obj1);
      });
    } else if (key === "move_selected_inactive") {
      selectedUsers.map((val, index) => {
        let obj = {
          appuserid: val.appuserid,
          eventid: session.eventid,
          isactive: 0,
          userwaitlistmode: 0,
        };
        users.push(obj);
      });
    }
    // console.log("users :- ", users);

    /**
     * Calculation for current page no. in pageination select
     */
    let leftRecord = userList.count - selectedUsers.length;
    var pageCount = Math.floor(leftRecord / itemCount);
    var pageExtraCount = Math.floor(leftRecord % itemCount);

    if (pageExtraCount > 0) {
      pageCount = pageCount + 1;
    }

    let newPageNo = pageNumber;
    if (pageNumber > pageCount) {
      newPageNo = pageCount;
    }

    if (
      (key === "move_selected_waitlist" ||
        key === "move_email_selected_waitlist" ||
        key === "move_selected_inactive") &&
      checkSelfAdmin.length > 0
    ) {
      this.props.showError(
        LocaleStrings.user_action_validation_you_cannot_waitlist_inactive_yourself
      );
    } else if (
      (key === "move_selected_waitlist" ||
        key === "move_email_selected_waitlist" ||
        key === "move_selected_inactive") &&
      checkSuperAdmin.length > 0
    ) {
      this.props.showError(
        _.replace(
          LocaleStrings.user_action_validation_you_cannot_waitlist_inactive_superadmin,
          "#superdamin",
          checkSuperAdmin[0].email
        )
      );
    } else {
      let title = "";
      let subtitle = "";
      let message = "";
      if (
        key === "move_selected_confirmed" ||
        key === "move_email_selected_confirmed"
      ) {
        title = LocaleStrings.user_title_move_user_to_confirmed;
        subtitle = LocaleStrings.user_subtitle_move_user_to_confirmed;
        message = LocaleStrings.user_message_move_user_to_confirmed_success;
      } else if (
        key === "move_selected_waitlist" ||
        key === "move_email_selected_waitlist"
      ) {
        title = LocaleStrings.user_title_move_user_to_waitlist;
        subtitle = LocaleStrings.user_subtitle_move_user_to_waitlist;
        message = LocaleStrings.user_message_move_user_to_waitlist_success;
      } else if (key === "move_selected_inactive") {
        title = LocaleStrings.user_title_move_user_to_inactive;
        subtitle = LocaleStrings.user_subtitle_move_user_to_inactive;
        message = LocaleStrings.user_message_move_user_to_inactive_success;
      }

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert-body">
              <h1>{title}</h1>
              <p>{subtitle}</p>

              <div className="react-confirm-alert-button-group">
                <button
                  type="button"
                  onClick={() => {
                    this.loadConfirmationButton();
                    this.props.appuserBasicDataUpdate(
                      session,
                      users,
                      (response) => {
                        if (response.success === 0) {
                          this.props.showError(COMMON_FAIL_MESSAGE);
                        } else {
                          this.paginationCallback(newPageNo);
                          this.reloadTotalUserData();
                          this.props.showSuccess(message);
                          this.clearAllData();
                          onClose();

                          if (
                            key === "move_email_selected_confirmed" ||
                            key === "move_email_selected_waitlist"
                          ) {
                            this.props.sendBulkWelcomeMail(session, emailuser);
                          }
                        }
                      }
                    );
                  }}
                  ref={this.confirmButtonOk}
                >
                  {LocaleStrings.button_ok}
                </button>
                <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
              </div>
            </div>
          );
        },
      });
    }
  };

  // Bulk delete appusers
  bulkDeleteAppUser = (key) => {
    // console.log("key :- ", key);

    if (key === "delete_selected") {
      let { selectedUsers, pageNumber } = this.state;
      let userId = this.props.session.userid;

      // Check self in delete appuser list
      var checkSelfAdmin = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid == userId;
      });

      // Check super admin in delete appuser list
      var checkSuperAdmin = _.filter(selectedUsers, function (selusers) {
        return selusers.issuperadmin;
      });

      let deleteData = [];
      selectedUsers.map((val, index) => {
        let obj = {};
        obj.appuserid = val.appuserid;
        deleteData.push(obj);
      });

      /**
       * Calculation for current page no. in pageination select
       */
      let leftRecord = this.props.userList.count - selectedUsers.length;
      var pageCount = Math.floor(leftRecord / itemCount);
      var pageExtraCount = Math.floor(leftRecord % itemCount);

      if (pageExtraCount > 0) {
        pageCount = pageCount + 1;
      }

      let newPageNo = pageNumber;
      if (pageNumber > pageCount) {
        newPageNo = pageCount;
      }

      if (checkSelfAdmin.length > 0) {
        this.props.showError(
          LocaleStrings.user_action_validation_you_cannot_delete_yourself
        );
      } else if (checkSuperAdmin.length > 0) {
        this.props.showError(
          _.replace(
            LocaleStrings.user_action_validation_you_cannot_delete_superadmin,
            "#superdamin",
            checkSuperAdmin[0].email
          )
        );
      } else {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="react-confirm-alert-body">
                <h1>{LocaleStrings.user_title_delete_users}</h1>
                <p>
                  {_.replace(
                    LocaleStrings.user_text_are_you_sure_delete,
                    "#total",
                    selectedUsers.length
                  )}
                </p>

                <div className="react-confirm-alert-button-group">
                  <button
                    type="button"
                    onClick={() => {
                      this.loadConfirmationButton();
                      this.props.deleteBulkAppUser(
                        this.props.session,
                        deleteData,
                        (response) => {
                          if (response.success === 0) {
                            this.props.showError(COMMON_FAIL_MESSAGE);
                          } else {
                            this.paginationCallback(newPageNo);
                            this.reloadTotalUserData();
                            this.props.showSuccess(
                              LocaleStrings.user_message_user_deleted
                            );
                            this.clearAllData();
                            onClose();
                          }
                        }
                      );
                    }}
                    ref={this.confirmButtonOk}
                  >
                    {LocaleStrings.button_ok}
                  </button>
                  <button onClick={onClose}>
                    {LocaleStrings.button_cancel}
                  </button>
                </div>
              </div>
            );
          },
        });
      }
    }

    // For now we are not allowing to delete all user, if required uncomment else section and check once.

    // else {
    //   confirmAlert({
    //     title: LocaleStrings.user_title_delete_users,
    //     message: `${LocaleStrings.user_text_are_you_sure_delete_all_other}?`,
    //     confirmLabel: LocaleStrings.button_ok,
    //     cancelLabel: LocaleStrings.button_cancel,
    //     buttons: [
    //       {
    //         label: LocaleStrings.button_ok,
    //         onClick: () => {
    //           this.props.bulkDeleteAllAppUser(
    //             this.props.session,
    //             (response) => {
    //               if (response.success === 0) {
    //                 this.props.showError(COMMON_FAIL_MESSAGE);
    //               } else {
    //                 this.paginationCallback(1);
    //                 this.props.showSuccess(
    //                   LocaleStrings.user_message_user_deleted
    //                 );
    //                 this.clearAllData();
    //               }
    //             }
    //           );
    //         },
    //       },
    //       {
    //         label: LocaleStrings.button_cancel,
    //         onClick: () => {},
    //       },
    //     ],
    //   });
    // }
  };

  // Bulk Check-in/Check-out appusers
  bulkCheckInOutAppUser = (key) => {
    // console.log("key :- ", key);
    let { selectedUsers, pageNumber } = this.state;
    let newPageNo = pageNumber;
    let title = "";
    let message = "";
    let success = "";

    let updatedData = [];
    if (key === "checkin_selected") {
      title = LocaleStrings.user_title_checkin_users;
      message = _.replace(
        LocaleStrings.user_text_are_you_sure_checkin,
        "#total",
        selectedUsers.length
      );
      success = LocaleStrings.user_message_user_marked_checked_in;
      selectedUsers.map((val) => {
        let obj = {};
        obj.appuserid = val.appuserid;
        obj.eventid = val.eventid;
        obj.checkedin = 1;
        obj.checkintime = moment().utc().format("YYYY-MM-DD HH:mm:ss");
        updatedData.push(obj);
      });
    } else {
      title = LocaleStrings.user_title_checkout_users;
      message = _.replace(
        LocaleStrings.user_text_are_you_sure_checkin,
        "#total",
        selectedUsers.length
      );
      success = LocaleStrings.user_message_user_marked_checked_out;
      selectedUsers.map((val) => {
        let obj = {};
        obj.appuserid = val.appuserid;
        obj.eventid = val.eventid;
        obj.checkedin = 0;
        updatedData.push(obj);
      });
    }
    // console.log("updatedData :- ", updatedData);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{title}</h1>
            <p>{message}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.loadConfirmationButton();

                  this.props.appuserBasicDataUpdate(
                    this.props.session,
                    updatedData,
                    (response) => {
                      if (response.success === 0) {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else {
                        this.paginationCallback(newPageNo);
                        this.reloadTotalUserData();
                        this.props.showSuccess(success);
                        this.clearAllData();
                        onClose();
                      }
                    }
                  );
                }}
                ref={this.confirmButtonOk}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  // Selecting one one user
  updateSelectedUser = (user) => {
    var selectedUsers = this.state.selectedUsers;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });

    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid !== user.appuserid;
      });

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      if (!user.deleted) {
        var newSelectUser = { ...user, checked: true };
        selectedUsers = [...selectedUsers, newSelectUser];
      }

      this.checkMatchArray(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  // Here we are looping total users and mark them checked and updating the state
  // selectTotalAppUser = () => {
  //   var selectedUsers = [];
  //   var allAppUsers = this.props.totalUsersList.resource;

  //   _.map(allAppUsers, user => {
  //       var newSelectUser={...user,checked:true};
  //       selectedUsers=[...selectedUsers,newSelectUser];

  //       this.setState({selectedUsers});
  //   });
  //   this.setState({showEmailPreviewModal: true})
  // }

  // Here we are looping to show user who are visiable on screen only
  selectAllUsers = () => {
    var state = this.state.allCheck;
    var selectedUsers = this.state.selectedUsers;
    var allUsers = this.props.userList.data;
    var newSelectUser = [];
    var newSelectedUsers = [];

    if (state == false) {
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === user.appuserid;
        });

        //Check if user is not exist in selected user that add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        }

        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
    } else {
      var leftUsers = selectedUsers;
      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          return selusers.appuserid !== user.appuserid;
        });
        leftUsers = newSelectedUsers;

        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
    }
  };

  // This function is used to show or hide action option and check or uncheck master check field
  checkMatchArray = (selectedUsers) => {
    setTimeout(() => {
      var userList = this.props.userList.data;

      var newArray = [];
      _.map(userList, (appUser) => {
        var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === appUser.appuserid;
        });

        if (newSelectedUsers && newSelectedUsers.length > 0) {
          // newArray = [...newArray, newSelectedUsers];
          newArray.push(newSelectedUsers[0]);
        }
      });

      // Check for current page selection and according to show or hide action option for bulk email send
      if (newArray.length > 0) {
        this.setState({ actionOption: true });
      } else {
        this.setState({ actionOption: false });
      }

      // Check for all user selected or not according to that check or uncheck master check option
      if (newArray.length > 0 && newArray.length === userList.length) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }
    }, 100);
  };

  paginationCallback = (pageNumber) => {
    let { search, sort, sortByCategory, selectedTab } = this.state;

    if (
      search == "" &&
      sort == "all" &&
      sortByCategory == "all" &&
      selectedTab == 1
    ) {
      this.props.fetchUserList(
        this.props.session,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        },
        this.props.userOrderByDateCreated.orderBy
      );
    } else if (
      search != "" &&
      sort == "all" &&
      sortByCategory == "all" &&
      selectedTab == 1
    ) {
      this.props.searchUser(
        this.props.session,
        search,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    } else if (
      search == "" &&
      sort == "all" &&
      sortByCategory != "all" &&
      selectedTab == 1
    ) {
      this.props.sortUserByCategory(
        this.props.session,
        sortByCategory,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    } else if (selectedTab == 1) {
      this.setState({ selectedUsers: [] });
      this.props.sortUser(
        this.props.session,
        sort,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    } else if (selectedTab == 2) {
      this.props.fetchUserbyUserStatus(
        this.props.session,
        "confirmed",
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    } else if (selectedTab == 3) {
      this.props.fetchUserbyUserStatus(
        this.props.session,
        "waitlist",
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    } else if (selectedTab == 4) {
      this.props.fetchUserbyUserStatus(
        this.props.session,
        "inactive",
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    }
    this.setState({ ...this.state, pageNumber });
  };

  exportUsers = (JSONData, ShowLabel) => {
    // this.JSONToCSVConvertor(this.props.downloadUser.data,true);
    this.JSONToCSVConvertor(JSONData, ShowLabel);
  };

  JSONToCSVConvertor(JSONData, ShowLabel) {
    // if (typeof XLSX == "undefined")
    var XLSX = require("xlsx");

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);
      // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "Users.xlsx");

    // CSV download code below with one sheet.

    // // Checking dynamic form
    // var eventForm = this.props.settingData && this.props.settingData.length>0 && this.props.settingData[0].event_forms_by_eventformid ? JSON.parse(this.props.settingData[0].event_forms_by_eventformid.formjson) : [];
    // var company = [];
    // var designation = [];
    // if(eventForm.length>0) {
    //   company = _.filter(eventForm, (obj) => {return obj.name === 'company'});
    //   designation = _.filter(eventForm, (obj) => {return obj.name === 'designation'});
    // }

    //   //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    //   var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    //   var CSV = '';
    //   //Set Report title in first row or line

    //   //CSV += ReportTitle + '\r\n\n';

    //   //This condition will generate the Label/Header
    //   if (ShowLabel) {
    //       var row = "";

    //       //This loop will extract the label from 1st index of on array
    //       for (var index in arrData[0]) {

    //         //Now convert each value to string and comma-seprated
    //         // if(index === 'username' || index === 'email')

    //         // Checking company and designation dynamic name from dynamic form
    //         if(company.length > 0 && designation.length > 0) {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'Company' || index === 'Designation' || index === 'QR')
    //             row += (index === 'Company' ? company[0].label : index === 'Designation' ? designation[0].label : index) + ',';
    //         }
    //         else if(company.length > 0 && designation.length == 0) {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'Company' || index === 'QR')
    //             row += (index === 'Company' ? company[0].label : index) + ',';
    //         }
    //         else if(company.length == 0 && designation.length > 0) {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'Designation' || index === 'QR')
    //             row += (index === 'Designation' ? designation[0].label : index) + ',';
    //         }
    //         else {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'QR')
    //             row += index + ',';
    //         }
    //       }

    //       row = row.slice(0, -1);

    //       //append Label row with line break
    //       CSV += row + '\r\n';
    //   }

    //   //1st loop is to extract each row
    //   for (var i = 0; i < arrData.length; i++) {
    //       var row = "";

    //       //2nd loop will extract each column and convert it in string comma-seprated
    //       for (var index in arrData[i]) {

    //         // Checking company and designation dynamic name from dynamic form
    //         if(company.length > 0 && designation.length > 0) {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'Company' || index === 'Designation' || index === 'QR')
    //             row += '"' + arrData[i][index] + '",';
    //         }
    //         else if(company.length > 0 && designation.length == 0) {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'Company' || index === 'QR')
    //             row += '"' + arrData[i][index] + '",';
    //         }
    //         else if(company.length == 0 && designation.length > 0) {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'Designation' || index === 'QR')
    //             row += '"' + arrData[i][index] + '",';
    //         }
    //         else {
    //           if(index === 'Firstname' || index === 'Lastname' || index === 'Email' || index === 'Usertype' || index === 'QR')
    //             row += '"' + arrData[i][index] + '",';
    //         }
    //       }

    //       row.slice(0, row.length - 1);

    //       //add a line break after each row
    //       CSV += row + '\r\n';
    //   }

    //   if (CSV == '') {
    //       alert("Invalid data");
    //       return;
    //   }

    //   //Generate a file name
    //   var fileName = "Users";
    //   //this will remove the blank-spaces from the title and replace it with an underscore
    //   //fileName += ReportTitle.replace(/ /g,"_");

    //   //Initialize file format you want csv or xls
    //   var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    //   // Now the little tricky part.
    //   // you can use either>> window.open(uri);
    //   // but this will not work in some browsers
    //   // or you will not get the correct file extension

    //   //this trick will generate a temp <a /> tag
    //   var link = document.createElement("a");
    //   link.href = uri;

    //   //set the visibility hidden so it will not effect on your web-layout
    //   link.style = "visibility:hidden";
    //   link.download = fileName + ".csv";

    //   //this part will append the anchor tag and remove it after automatic click
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
  }

  /**
   * User search by input
   */
  onSearchUser = (event) => {
    var search = event.target.value;
    let pageNumber = 1;
    if (search === "") {
      this.props.fetchUserList(
        this.props.session,

        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        },
        this.props.userOrderByDateCreated.orderBy
      );
    } else {
      this.props.searchUser(
        this.props.session,
        search,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    }
    this.setState({
      search,
      sort: "all",
      sortByCategory: "all",
      pageNumber,
      selectedTab: 1,
    });

    this.alphabetsFun("all");
    this.clearAllData();
  };
  /**
   * =============================================================================================
   */

  /**
   * Search by alphabets
   */
  alphabetsFun = (search) => {
    var first = "A",
      last = "Z";
    var alpha = [
      <span
        onClick={this.clickedAlpha}
        key="all"
        className={search === "all" ? "activeA" : "unactive"}
      >
        {LocaleStrings.all}
      </span>,
    ];
    for (var i = first.charCodeAt(0); i <= last.charCodeAt(0); i++) {
      alpha.push(
        <span
          onClick={this.clickedAlpha}
          key={i}
          className={
            search === eval("String.fromCharCode( " + i + " )")
              ? "activeA"
              : "unactive"
          }
        >
          {eval("String.fromCharCode( " + i + " )")}
        </span>
      );
    }
    this.setState({
      alphabets: alpha,
    });
  };

  clickedAlpha = (e) => {
    e.preventDefault();
    this.setState({ selectedUsers: [] });
    var sort = e.target.textContent;
    let pageNumber = 1;
    if (sort === "all") {
      this.props.fetchUserList(
        this.props.session,

        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        },
        this.props.userOrderByDateCreated.orderBy
      );
    } else {
      this.props.sortUser(
        this.props.session,
        sort,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    }
    this.setState({
      sort: sort,
      search: "",
      sortByCategory: "all",
      pageNumber,
    });
    this.alphabetsFun(sort);
    this.clearAllData();
  };
  /**
   * =============================================================================================
   */

  /**
   * Sort by user category
   */
  sortByUserCategory = (e) => {
    e.preventDefault();
    var sortByCategory = e.target.value;
    this.setState({ selectedUsers: [] });

    let pageNumber = 1;
    if (sortByCategory === "all") {
      this.props.fetchUserList(
        this.props.session,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        },
        this.props.userOrderByDateCreated.orderBy
      );
    } else {
      this.props.sortUserByCategory(
        this.props.session,
        sortByCategory,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(this.state.selectedUsers);
        }
      );
    }
    this.setState({
      sortByCategory,
      sort: "all",
      search: "",
      selectedTab: 1,
      pageNumber,
    });
    this.alphabetsFun("all");
    this.clearAllData();
  };
  /**
   * =============================================================================================
   */

  handleUserStatusTab(e) {
    let { session, userOrderByDateCreated } = this.props;
    let selectedUsers = [];
    let pageNumber = 1;
    let key = e.target.value;
    // Key 1 == All, Key 2 == Confirmed, Key 3 == Waitlist, Key 4 == Inactive
    // console.log("key :- ", key);

    this.props.clearUserList(); // Clear the user list

    if (key == 2) {
      this.props.fetchUserbyUserStatus(
        session,
        "confirmed",
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(selectedUsers);
        }
      );
    } else if (key == 3) {
      this.props.fetchUserbyUserStatus(
        session,
        "waitlist",
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(selectedUsers);
        }
      );
    } else if (key == 4) {
      this.props.fetchUserbyUserStatus(
        session,
        "inactive",
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(selectedUsers);
        }
      );
    } else {
      this.props.fetchUserList(
        session,
        pageNumber,
        0,
        (response) => {
          this.checkMatchArray(selectedUsers);
        },
        userOrderByDateCreated.orderBy
      );
    }

    this.setState({
      selectedTab: key,
      sort: "all",
      sortByCategory: "all",
      search: "",
      pageNumber,
    });
    this.alphabetsFun("all");
    this.clearAllData();
  }

  toggleFilterByCreatedOn() {
    let { selectedUsers, pageNumber } = this.state;
    selectedUsers = [];

    this.setState({ selectedUsers: [], pageNumber: 1 });

    if (this.props.userOrderByDateCreated.orderBy == "desc") {
      this.props.sortUserByDateOrder("asc");
      this.props.fetchUserList(this.props.session, 0, 0, (res) => {}, "asc");
    } else {
      this.props.sortUserByDateOrder("desc");
      this.props.fetchUserList(this.props.session, 0, 0, (res) => {}, "desc");
    }
  }

  handleSelectAllUsers() {
    let { userList, totalUsersList } = this.props;
    let { selectedUsers, selectedTab, search, sort, sortByCategory } =
      this.state;
    let allUsers = [];
    var newSelectedUsers = [];
    // console.log("userList :- ", userList);
    // console.log("selectedTab :- ", selectedTab);
    // console.log("search :- ", search);
    // console.log("sort :- ", sort);
    // console.log("sortByCategory :- ", sortByCategory);
    // console.log("totalUsersList :- ", totalUsersList);

    if (selectedTab == 2) {
      allUsers = _.filter(totalUsersList.resource, (o) => {
        return o.isactive == 1 && o.userwaitlistmode == 0;
      });
    } else if (selectedTab == 3) {
      allUsers = _.filter(totalUsersList.resource, (o) => {
        return o.isactive == 1 && o.userwaitlistmode == 1;
      });
    } else if (selectedTab == 4) {
      allUsers = _.filter(totalUsersList.resource, (o) => {
        return o.isactive == 0 && o.userwaitlistmode == 0;
      });
    } else {
      if (search === "" && sort === "all" && sortByCategory === "all") {
        allUsers = totalUsersList.resource;
      } else if (search !== "" && sort === "all" && sortByCategory === "all") {
        let match = _.filter(totalUsersList.resource, (o) => {
          return (
            o.email.toLowerCase().indexOf(search) !== -1 ||
            o.username.toLowerCase().indexOf(search) !== -1
          );
        });
        allUsers = match;
      } else if (search === "" && sort === "all" && sortByCategory !== "all") {
        let match = _.filter(totalUsersList.resource, (o) => {
          return o.usercategory.indexOf(sortByCategory) !== -1;
        });
        allUsers = match;
      } else if (search === "" && sort !== "all" && sortByCategory === "all") {
        let match = _.filter(totalUsersList.resource, (o) => {
          return o.username.toLowerCase().indexOf(sort.toLowerCase()) === 0;
        });
        allUsers = match;
      } else {
        allUsers = totalUsersList.resource;
      }
    }
    console.log("allUsers :- ", allUsers);

    if (selectedUsers.length == userList.count) {
      allUsers.map((v) => {
        delete v["checked"];
      });

      this.checkMatchArray([]);
      this.setState({ selectedUsers: [] });
    } else {
      newSelectedUsers = allUsers.map((v) => ({ ...v, checked: true }));

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    }
  }

  renderUserList() {
    let pageDataLength = this.props.userList.data.length;
    let { pageNumber } = this.state;

    return _.map(this.props.userList.data, (appUser) => {
      return (
        <DashboardUserItem
          key={appUser.appuserid}
          appUser={appUser}
          eventDetails={this.props.eventDetails}
          refreshTotalUser={this.reloadTotalUserData}
          pagination={this.paginationCallback}
          checkAndUncheckUsers={this.updateSelectedUser}
          selectedUsers={this.state.selectedUsers}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          selectedTab={this.state.selectedTab}
        />
      );
    });
  }

  render() {
    var {
      deviceSize,
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      userRestPasswordModal,
      userCategoryList,
      appuserGroupManageModal,
      userList,
      userOrderByDateCreated,
    } = this.props;
    let {
      selectedTab,
      selectedUsers,
      sortByCategory,
      allCheck,
      actionOption,
      pageNumber,
    } = this.state;

    // console.log(
    //   "allCheck, actionOption, selectedUsers",
    //   this.state.allCheck,
    //   this.state.actionOption,
    //   this.state.selectedUsers
    // );

    var disabled = false;
    if (userList.data) {
      disabled = userList.data.length === 0;
    }

    let userStatus = [
      { label: LocaleStrings.user_waitlist_type_all, value: 1 },
      { label: LocaleStrings.user_waitlist_type_confirmed, value: 2 },
      { label: LocaleStrings.user_waitlist_type_waiting, value: 3 },
      { label: LocaleStrings.user_waitlist_type_inactive, value: 4 },
    ];

    var categories = [{ label: LocaleStrings.filter_by_all, value: "all" }];
    if (
      userCategoryList &&
      userCategoryList.data &&
      userCategoryList.data.length > 0
    ) {
      userCategoryList.data.forEach((item, index) => {
        var obj = { label: item.groupname, value: item.id.toString() };
        categories.push(obj);
      });
    }
    categories.push({
      label: LocaleStrings.user_filterby_option_checkindin,
      value: "checkedin",
    });

    const mapObj = {
      startnum: pageNumber === 1 ? 1 : itemCount * (pageNumber - 1) + 1,
      endnum:
        userList.count > itemCount * pageNumber
          ? itemCount * pageNumber
          : userList.count,
      totalnum: userList.count,
    };

    return (
      <div className={this.state.activeLoader ? "user_main_div" : ""}>
        <div className="content-header-bar">
          {/* ------- bread-crum & user count ------ */}
          <div className="header-buttons">
            {/* <div className="user-reg-breadcrum">
              <Tabs
                id="userstatus"
                activeKey={selectedTab}
                onSelect={this.handleUserStatusTab}
              >
                <Tab
                  eventKey={1}
                  title={`${LocaleStrings.user_waitlist_type_all}`}
                />
                <Tab
                  eventKey={2}
                  title={`${LocaleStrings.user_waitlist_type_confirmed}`}
                />
                <Tab
                  eventKey={3}
                  title={`${LocaleStrings.user_waitlist_type_waiting}`}
                />
                <Tab
                  eventKey={4}
                  title={`${LocaleStrings.user_waitlist_type_inactive}`}
                />
              </Tabs>
            </div> */}
            <select
              className="dropdown-height-border"
              onChange={this.handleUserStatusTab}
              value={selectedTab}
              style={{ width: 140 }}
            >
              {userStatus.map((object, index) => {
                return (
                  <option key={`${object.value}-${index}`} value={object.value}>
                    {object.label}
                  </option>
                );
              })}
            </select>
            <select
              className="dropdown-height-border"
              onChange={this.sortByUserCategory}
              value={sortByCategory}
              style={{ width: 140 }}
            >
              {categories.map((object, index) => {
                return (
                  <option key={`${object.value}-${index}`} value={object.value}>
                    {object.label}
                  </option>
                );
              })}
            </select>
          </div>

          {/* ------ search - add user - manage - action buttons ------- */}

          <ul className="header-buttons">
            <li className="users-search-input widthusers-tab">
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.button_search}
                type="text"
                value={this.state.search}
                onChange={this.onSearchUser}
              />
            </li>
            <li>
              <AddUserDialog
                finishOperationsCallback={this.userAdditionCallback}
                history={this.props.history}
                pagination={this.paginationCallback}
                currentPage={this.state.pageNumber}
                checkAndUncheckUsers={this.updateSelectedUser}
                pageDataLength={
                  userList && userList.data ? userList.data.length : 0
                }
              />
            </li>
            <li>
              <Button
                type="button"
                className="btn-custom-blue"
                onClick={this.openGroupManageModal}
              >
                {LocaleStrings.button_manage_user_group}
              </Button>
            </li>
            <li>
              <ExportUsers JSONToCSVConvertor={this.exportUsers} />
            </li>
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <li>
                <ImportUsersDialog
                  callbackUploadUser={this.callbackUploadUser}
                  refreshPage={this.reloadPageData}
                />
              </li>
            )}
          </ul>
        </div>

        {/* Dispaly this sesion only when all list tab is selected */}
        {selectedTab == 1 ? (
          <div className="sub-header-bar header-buttons">
            <div className="h-100 vertical-align-center">
              <div className="alphaStyle users-alpha">
                {this.state.alphabets}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {userList.count > 0 ? (
          <div className="sub-header-bar header-buttons vertical-align-center-justify-between">
            <div className="h-100 vertical-align-center">
              <ul className="select-all-checkbox-section">
                <li>
                  <label className="custom-container-checkbox">
                    <input
                      type="checkbox"
                      onChange={this.selectAllUsers}
                      checked={allCheck}
                    />
                    <span className="checkmark" />
                  </label>
                </li>
                <li>
                  <span style={{ fontWeight: "bold", marginRight: 15 }}>
                    {LocaleStrings.user_option_select_all}
                  </span>
                </li>
                <li>
                  <div className="dropdown-btn-container ml-2">
                    {actionOption === true ? (
                      <DropdownButton
                        className="dropdown-blue-carret-btn"
                        title=""
                        key="1"
                        id="dropdown-basic-2"
                        // bsSize="xsmall"
                        nocaret="true"
                      >
                        {selectedTab == 1 || selectedTab == 2 ? (
                          <Dropdown.Item
                            eventKey="email_selected_confirmed"
                            onClick={() =>
                              this.sendBulkEmail("email_selected_confirmed")
                            }
                          >
                            {
                              LocaleStrings.user_option_send_welcome_email_selected
                            }
                          </Dropdown.Item>
                        ) : (
                          ""
                        )}

                        {selectedTab == 1 || selectedTab == 3 ? (
                          <Dropdown.Item
                            eventKey="email_selected_waitlist"
                            onClick={() =>
                              this.sendBulkEmail("email_selected_waitlist")
                            }
                          >
                            {
                              LocaleStrings.user_option_send_waitlist_email_selected
                            }
                          </Dropdown.Item>
                        ) : (
                          ""
                        )}

                        {selectedTab == 2 || selectedTab == 4 ? (
                          <>
                            <Dropdown.Item
                              eventKey="move_selected_waitlist"
                              onClick={() =>
                                this.updateBulkUserStatus(
                                  "move_selected_waitlist"
                                )
                              }
                            >
                              {
                                LocaleStrings.user_option_move_user_to_waitlist_selected
                              }
                            </Dropdown.Item>
                            <Dropdown.Item
                              eventKey="move_email_selected_waitlist"
                              onClick={() =>
                                this.updateBulkUserStatus(
                                  "move_email_selected_waitlist"
                                )
                              }
                            >
                              {
                                LocaleStrings.user_option_move_user_to_waitlist_with_email_selected
                              }
                            </Dropdown.Item>
                          </>
                        ) : (
                          ""
                        )}

                        {selectedTab == 3 || selectedTab == 4 ? (
                          <>
                            <Dropdown.Item
                              eventKey="move_selected_confirmed"
                              onClick={() =>
                                this.updateBulkUserStatus(
                                  "move_selected_confirmed"
                                )
                              }
                            >
                              {
                                LocaleStrings.user_option_move_user_to_confirmed_selected
                              }
                            </Dropdown.Item>
                            <Dropdown.Item
                              eventKey="move_email_selected_confirmed"
                              onClick={() =>
                                this.updateBulkUserStatus(
                                  "move_email_selected_confirmed"
                                )
                              }
                            >
                              {
                                LocaleStrings.user_option_move_user_to_confirmed_with_email_selected
                              }
                            </Dropdown.Item>
                          </>
                        ) : (
                          ""
                        )}

                        {selectedTab == 2 || selectedTab == 3 ? (
                          <>
                            <Dropdown.Item
                              eventKey="move_selected_inactive"
                              onClick={() =>
                                this.updateBulkUserStatus(
                                  "move_selected_inactive"
                                )
                              }
                            >
                              {
                                LocaleStrings.user_option_move_user_to_inactive_selected
                              }
                            </Dropdown.Item>
                          </>
                        ) : (
                          ""
                        )}

                        <Dropdown.Item
                          eventKey="delete_selected"
                          onClick={() =>
                            this.bulkDeleteAppUser("delete_selected")
                          }
                        >
                          {LocaleStrings.user_option_delete_selected}
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="checkin_selected"
                          onClick={() =>
                            this.bulkCheckInOutAppUser("checkin_selected")
                          }
                        >
                          {LocaleStrings.user_option_checkin_selected}
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="checkout_selected"
                          onClick={() =>
                            this.bulkCheckInOutAppUser("checkout_selected")
                          }
                        >
                          {LocaleStrings.user_option_checkout_selected}
                        </Dropdown.Item>
                      </DropdownButton>
                    ) : (
                      ""
                    )}
                  </div>
                </li>
              </ul>
              {selectedUsers.length > 0 ? (
                <div className="ml-10">
                  {userList.count == selectedUsers.length ? (
                    <span>
                      {_.replace(
                        LocaleStrings.user_text_all_users_selected,
                        "#total",
                        userList.count
                      )}
                    </span>
                  ) : (
                    <span>
                      {_.replace(
                        LocaleStrings.user_text_total_selected_user,
                        "#total",
                        selectedUsers.length
                      )}
                    </span>
                  )}

                  <span
                    className="text-primary cursor-pointer ml-10"
                    onClick={this.handleSelectAllUsers}
                  >
                    {userList.count == selectedUsers.length
                      ? LocaleStrings.user_text_clear_all_selected_users
                      : _.replace(
                          LocaleStrings.user_text_select_all_usera,
                          "#total",
                          userList.count
                        )}
                  </span>
                </div>
              ) : null}
            </div>

            <div className="h-100 vertical-align-center">
              <div className="data-counting-per-page">
                {LocaleStrings.user_counting_per_page.replace(
                  /startnum|endnum|totalnum/gi,
                  (matched) => mapObj[matched]
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content pt-0"
          style={{
            height:
              deviceSize.height -
              (screenHeightLeftFromTop + (selectedTab == 1 ? 100 : 50)),
          }}
        >
          {userList && userList.data ? (
            <>
              {userList.data && userList.data.length > 0 ? (
                <div className="main-table-container">
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ width: "3%" }}>#</th>
                        <th style={{ width: "25%" }}>
                          {LocaleStrings.user_table_list_name}
                        </th>
                        {/* <th>Email</th> */}
                        <th style={{ width: "15%" }}>
                          {LocaleStrings.user_table_list_checked_in_status}
                        </th>
                        {/* <th style={{ width: "15%" }}>
                        {LocaleStrings.user_table_list_mark_approved}
                      </th> */}
                        {/*<th>Password</th>*/}
                        <th
                          onClick={this.toggleFilterByCreatedOn}
                          className="cursor-pointer"
                        >
                          <div className="vertical-align-center">
                            {LocaleStrings.user_table_list_added_on_date}
                            <span>
                              {userOrderByDateCreated.orderBy === "asc" ? (
                                <img
                                  src="../../style/images/icons/caret-down.svg"
                                  alt="caret-down"
                                />
                              ) : (
                                <img
                                  src="../../style/images/icons/caret-up.svg"
                                  alt="caret-up"
                                />
                              )}
                            </span>
                          </div>
                        </th>
                        <th style={{ width: "35%" }}>
                          {LocaleStrings.user_table_list_action}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderUserList()}
                    </tbody>
                  </table>

                  {this.props.userList &&
                  this.props.userList.count > itemCount ? (
                    <div>
                      <Pagination
                        activePage={this.state.pageNumber}
                        itemsCountPerPage={itemCount}
                        totalItemsCount={this.props.userList.count}
                        pageRangeDisplayed={10}
                        onChange={this.paginationCallback}
                        style={{ float: "right" }}
                      />
                    </div>
                  ) : null}
                </div>
              ) : (
                <NoContent
                  contentType={NO_USER}
                  connectFor={
                    selectedTab == 2
                      ? "confirmed"
                      : selectedTab == 3
                      ? "waitlist"
                      : selectedTab == 4
                      ? "inactive"
                      : "all"
                  }
                />
              )}

              {userRestPasswordModal && userRestPasswordModal.show ? (
                <UserResetPassword />
              ) : null}
              {this.props.ShowUserCategoryModal ? (
                <ManageUsersGroup
                  finishOperationsCallback={this.userAdditionCallback}
                />
              ) : null}
              {appuserGroupManageModal && appuserGroupManageModal.showModal ? (
                <ManageAppuserGroup
                  finishOperationsCallback={this.userAdditionCallback}
                />
              ) : null}
            </>
          ) : (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const toggleFilterByDateAscending = () => {
  this.setState({ sortByDateAscending: !this.state.sortByDateAscending });
};

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    userList: state.dashboardUserList,
    dashboardUserList: state.dashboardUserList,

    totalUsersList: state.dashboardTotalUsers,
    userOrderByDateCreated: state.userOrderByDateCreated,
    user: state.user,
    eventDetails: state.userEventDetails,
    bulkUplodingLeft: state.bulkUserUplodingLeft,
    downloadUser: state.downloadUser,
    settingData: state.SettingData ? state.SettingData.resource : [],
    userRestPasswordModal: state.userRestPasswordModal,
    ShowUserCategoryModal: state.ShowDashboardUserCategoryModal,
    userCategoryList: state.userCategoryList,
    appuserGroupManageModal: state.appuserGroupManageModal,
  };
}

export default connect(
  mapStateToProps,
  {
    clearUserList,
    fetchUserList,
    fetchTotalUsers,
    searchUser,
    sortUser,
    sortUserByCategory,
    fetchUserbyUserStatus,
    sortUserByDateOrder,
    fetchUsersCategory,
    showError,
    showSuccess,
    fetchEventDetails,
    deleteBulkAppUser,
    bulkDeleteAllAppUser,
    appuserBasicDataUpdate,
    sendBulkWelcomeMail,
    fetchBulkUplodedLeftUsers,
    fetchSettings,
    fetchTemplate,
    fetchAllSpeakers,
    fetchAllSponsors,
    fetchAllExhibitors,
    fetchUserInterests,
    manageUserGroupModal,
    fetchUserListForManageUserGroup,
    fetchAllTickets,
  },
  null,
  { forwardRef: true }
)(Users);
